import { Configuration, PopupRequest } from "@azure/msal-browser";

// Configurazione MSAL
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "your-client-id-here", // Sostituisci con il tuo Client ID
    authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/your-tenant-id", // Sostituisci con il tuo Tenant ID
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000", // URL di redirect dopo il login
    postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT_URI || "http://localhost:3000", // URL di redirect dopo il logout
  },
  cache: {
    cacheLocation: "localStorage", // Opzioni: "sessionStorage" o "localStorage"
    storeAuthStateInCookie: false, // Impostare su true per IE 11 o Edge
  }
};

// Scopes richiesti per l'applicazione
export const loginRequest: PopupRequest = {
  // scopes: ["openid", "profile", "email", "api://8ee6e6e3-d508-4dee-99d1-3dfeb05fc3be/Admin.Access"]
  scopes: ["openid", "profile", "email", "api://0929920a-122c-4dc0-93d2-6fede34f0cb4/admin.acces"]
};

// Scopes aggiuntivi per Microsoft Graph API
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMePhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};

// Scopes per chiamare Microsoft Graph
export const graphScopes = {
  scopes: ["User.Read"]
};

// Scopes per chiamare l'API
export const apiScopes = {
  // scopes: ["openid", "profile", "email", "api://8ee6e6e3-d508-4dee-99d1-3dfeb05fc3be/Admin.Access"]
  scopes: ["openid", "profile", "email", "api://0929920a-122c-4dc0-93d2-6fede34f0cb4/admin.acces"]

};